import React from 'react'

const Jva_map = () => {
    return (
        <div className='container'>
            <div class="">
 
 <h1 >Java Map</h1>

 <div id="pageToc" itemscope="" itemtype="http://schema.org/SiteNavigationElement">
       <ul>
             <li><a href="#java-map-tutorial-video">Java Map Tutorial Video</a></li>
             <li><a href="#implementations">Java Map Implementations</a></li>
             <li><a href="#create-a-map">Create a Map</a></li>
             <li><a href="#generic-java-map">Generic Java Map</a></li>
             <li><a href="#insert">Inserting Elements Into a Java Map</a>
                   <ul>
                         <li><a href="#only-objects-can-inserted">Only Objects Can Be Inserted</a></li>
                         <li><a href="#subsequent-inserts-with-same-key">Subsequent Inserts With Same Key</a></li>
                   </ul>
             </li>
             <li><a href="#null-keys">Null Keys</a></li>
             <li><a href="#null-values">Null Values</a></li>
             <li><a href="#inserting-all-elements-from-another-map">Inserting All Elements From Another Map</a>
             </li>
             <li><a href="#get-elements-from-java-map">Get Elements From a Java Map</a>
                   <ul>
                         <li><a href="#get-or-default-value">Get or Default Value</a></li>
                   </ul>
             </li>
             <li><a href="#checking-if-map-contains-key">Checking if Map Contains Key</a></li>
             <li><a href="#checking-if-map-contains-value">Checking if Map Contains Value</a></li>
             <li><a href="#iterating-the-keys-of-a-java-map">Iterating the Keys of a Java Map</a>
                   <ul>
                         <li><a href="#using-a-key-iterator">Using a Key Iterator</a></li>
                         <li><a href="#using-a-key-for-each-loop">Using a Key For-Each Loop</a></li>
                         <li><a href="#using-a-key-stream">Using a Key Stream</a></li>
                   </ul>
             </li>
             <li><a href="#iterating-the-values-of-a-java-map">Iterating the Values of a Java Map</a>
                   <ul>
                         <li><a href="#using-a-value-iterator">Using a Value Iterator</a></li>
                         <li><a href="#using-a-value-for-each-loop">Using a Value For-Each Loop</a></li>
                         <li><a href="#using-a-value-stream">Using a Value Stream</a></li>
                   </ul>
             </li>
             <li><a href="#iterating-the-entries-of-a-java-map">Iterating the Entries of a Java Map</a>
                   <ul>
                         <li><a href="#using-an-entry-iterator">Using an Entry Iterator</a></li>
                         <li><a href="#using-an-entry-for-each-loop">Using an Entry For-Each Loop</a></li>
                   </ul>
             </li>
             <li><a href="#remove">Removing Entries From a Java Map</a></li>
             <li><a href="#removing-all-entries">Removing All Entries</a></li>
             <li><a href="#replacing-an-entry-in-a-java-map">Replacing an Entry in a Java Map</a></li>
             <li><a href="#reading-number-of-entries-in-map">Reading Number of Entries in Map</a></li>
             <li><a href="#checking-if-a-java-map-is-empty">Checking if a Java Map is Empty</a></li>
             <li><a href="#functional-operations">Functional Operations in Java Map</a>
                   <ul>
                         <li><a href="#compute">compute()</a></li>
                         <li><a href="#computeifabsent">computeIfAbsent()</a></li>
                         <li><a href="#computeifpresent">computeIfPresent()</a></li>
                         <li><a href="#merge">merge()</a></li>
                   </ul>
             </li>
             <li><a href="#javadoc">More Details in the Java Map JavaDoc</a></li>
       </ul>
 </div>
 

 <div id="mainBody">
       <p>
             The <em>Java Map</em> interface, <code>java.util.Map</code>, represents a mapping between a key and a
             value.
             More specifically, a <em>Java</em> <em>Map</em> can store pairs of keys and values. Each key is linked
             to a specific
             value. Once stored in a <code>Map</code>, you can later look up the value using just the key.
       </p>

       <p>
             The Java <code>Map</code> interface is not a subtype of the <code>Collection</code> interface.
             Therefore it behaves a bit different from the rest of the collection types.
       </p>



       <a name="java-map-tutorial-video"></a>
       <h2>Java Map Tutorial Video</h2>

       <p>
             If you prefer video, I have a video version of this Java Map tutorial available here:
             <a href="https://www.youtube.com/watch?v=UfBaTKaSSRg" target="_blank">Java Map Tutorial</a>
       </p>

      




       <a name="implementations"></a>
       <h2>Java Map Implementations</h2>
       <p>
             Since <code>Map</code> is an interface you need to instantiate a concrete implementation
             of the <code>Map</code> interface in order to use it. The Java Collections API contains the following
             <code>Map</code>
             implementations:
       </p>

       <ul>
             <li>java.util.HashMap</li>
             <li>java.util.Hashtable</li>
             <li>java.util.EnumMap</li>
             <li>java.util.IdentityHashMap</li>
             <li>java.util.LinkedHashMap</li>
             <li>java.util.Properties</li>
             <li>java.util.TreeMap</li>
             <li>java.util.WeakHashMap</li>
       </ul>

       <p>
             In my experience, the most commonly used <code>Map</code> implementations are
             <code>HashMap</code> and <code>TreeMap</code>.
       </p>

       <p>
             Each of these <code>Map</code> implementations behaves a little differently with
             respect to the order of the elements when iterating the <code>Map</code>, and the
             time (big O notation) it takes to insert and access elements in the maps.
       </p>

       <p>
             <code>HashMap</code> maps a key and a value. It does not guarantee any order of
             the elements stored internally in the map.
       </p>

       <p>
             <code>TreeMap</code> also maps a key and a value. Furthermore it guarantees the
             order in which keys or values are iterated - which is the sort order of the keys
             or values. Check out the Java <code>Map</code> JavaDoc for more details.
       </p>

       <p>
             The HashMap implementation is typically the fastest of the two Map implementations, so whenever you
             don't need to sort the elements in the Map you can just use a HashMap. Otherwise use a TreeMap.
       </p>




       <a name="create-a-map"></a>
       <h2>Create a Map</h2>

       <p>
             To create a Java Map you must create an instance of one the classes that implement the Java Map
             interface.
             Here are a few examples of how to create a <code>Map</code> instance:
       </p>

       <pre class="containers">Map mapA = new HashMap();  <br/>
<br/>
Map mapB = new TreeMap(); <br/>
</pre>



       <a name="generic-java-map"></a>
       <h2>Generic Java Map</h2>
       <p>
             By default you can put any <code>Object</code> into a <code>Map</code>, but from Java 5, Java Generics
             makes it possible to limit the types of object you can use for both keys and values in a
             <code>Map</code>. Here is an example:
       </p>

       <pre class="containers">Map&lt;String, MyObject&gt; map =  <br/>
new HashMap&lt;String, MyObject&gt;(); <br/>
</pre>

       <p>
             This <code>Map</code> can now only accept <code>String</code> objects for keys, and
             <code>MyObject</code> instances
             for values. You can then access and iterate keys and values without casting them. Here is how it
             looks:
       </p>

       <pre class="containers">for(MyObject anObject : map.values())&#123;  <br/>
//do someting with anObject... <br/>
&#125; <br/>
<br/>
for(String key : map.keySet())&#123; <br/>
MyObject value = map.get(key); <br/>
//do something to value <br/>
&#125; <br/>
</pre>

       <p>
             If you know the type of the objects being stored in the Map it is considered good practice to always
             specify
             a generic type when declaring and creating a Java Map. The generic type helps you avoid inserting the
             wrong
             objects, and makes it easier for people reading your code to understand what kind of objects the Map
             contains.
             Throughout the rest of this tutorial I will be using generic types on all Map examples whenever it
             makes sense.
       </p>

      




       <a name="insert"></a>
       <h2>Inserting Elements Into a Java Map</h2>
       <p>
             To add elements to a <code>Map</code> you call its <code>put()</code> method.
             Here are a few examples:
       </p>

       <pre class="containers">Map&lt;String, String&gt; map = new HashMap&lt;&gt;(); <br/>
<br/>
map.put("key1", "element 1"); <br/>
map.put("key2", "element 2"); <br/>
map.put("key3", "element 3"); <br/>
</pre>

       <p>
             The three <code>put()</code> calls maps a string value to a string key. You can then
             obtain the value using that key, as we will see in the next section.
       </p>




       <a name="only-objects-can-inserted"></a>
       <h3>Only Objects Can Be Inserted</h3>
       <p>
             Only Java objects can be used as keys and values in a Java Map. In case you pass primitive values
             (e.g. int, double etc.)
             to a <code>Map</code> as key or value, the primitive values will be auto-boxed before being passed as
             parameters.
             Here is an example of auto-boxing primitive parameters passed to the <code>put()</code> method:
       </p>

       <pre class="containers">map.put("key", 123);
</pre>

       <p>
             The value passed to the <code>put()</code> method in the above example is a primitive
             <code>int</code>. Java
             auto-boxes it inside an <code>Integer</code> instance though, because the <code>put()</code> method
             requires
             an <code>Oject</code> instance as both key and value. Auto-boxing would also happen if you passed a
             primitive
             as key to the <code>put()</code> method.
       </p>



       <a name="subsequent-inserts-with-same-key"></a>
       <h3>Subsequent Inserts With Same Key</h3>
       <p>
             A given key can only occur in a Java <code>Map</code> one time. That means, that only a single key +
             value pair
             for each key can exist in the <code>Map</code> at the same time. In other words, for the key "key1"
             only one
             value can be stored in the same <code>Map</code> instance. Of course you can store values for the same
             key
             in different <code>Map</code> instances.
       </p>

       <p>
             If you call <code>put()</code> more than once with the same key, the latest value passed to
             <code>put()</code>
             for that key will overwrite what is already stored in the <code>Map</code> for that key. In other
             words, the
             latest value replaces the existing value for the given key.
       </p>




       <a name="null-keys"></a>
       <h2>Null Keys</h2>

       <p>
             Quite surprisingly you can use the value <code>null</code> as a key in a Java Map. Here is an example
             of
             using a <code>null</code> key in a Java Map:
       </p>

       <pre class="containers">Map map = new HashMap();

map.put(null, "value for null key");
</pre>

       <p>
             To obtain the value stored by the <code>null</code> key you call the <code>get()</code> method with
             <code>null</code>
             as parameter value. Here is an example of getting the value for the <code>null</code> key of a Java
             Map:
       </p>

       <pre class="containers">Map&lt;String, String&gt; map = new HashMap&lt;&gt;();

String value = map.get(null);
</pre>



       <a name="null-values"></a>
       <h2>Null Values</h2>
       <p>
             The value of a key + value pair stored in a <code>Map</code> is allowed to be null - so this is valid:
       </p>

       <pre class="containers">map.put("D", null);
</pre>

       <p>
             Just keep in mind that you will get a null out when you call <code>get()</code> later with that key -
             so this
             will return null:
       </p>

       <pre class="containers">Object value = map.get("D");
</pre>

       <p>
             The <code>value</code> variable will have the value <code>null</code> after this code has been
             executed,
             if a <code>null</code> value was inserted for this key earlier (like in the previous example).
       </p>




       <a name="inserting-all-elements-from-another-map"></a>
       <h2>Inserting All Elements From Another Map</h2>

       <p>
             The Java <code>Map</code> interface has a method called <code>putAll()</code> which can copy all key +
             value
             pairs (entries) from another <code>Map</code> instance into itself. In set theory, this is also
             referred
             to as the <em>union</em> of the two <code>Map</code> instances.
       </p>

       <p>
             Here is an example of copying all entries from one Java <code>Map</code> into another via
             <code>putAll()</code>:
       </p>


       <pre class="containers">Map&lt;String, String&gt; mapA = new HashMap&lt;&gt;(); <br/>
mapA.put("key1", "value1"); <br/>
mapA.put("key2", "value2"); <br/>
<br/>
Map&lt;String, String&gt; mapB = new HashMap&lt;&gt;(); <br/>
mapB.putAll(mapA); <br/>
</pre>

       <p>
             After running this code the <code>Map</code> referenced by variable <code>mapB</code> will contain
             both
             of the key + value entries inserted into <code>mapA</code> at the beginning of the code example.
       </p>

       <p>
             The copying of entries only goes one way. Calling <code>mapB.putAll(mapA)</code> will only copy
             entries
             from <code>mapA</code> into <code>mapB</code>, not from <code>mapB</code> into <code>mapA</code>. To
             copy
             entries the other way, you would have to execute the code <code>mapA.putAll(mapB)</code>.
       </p>




       <a name="get-elements-from-java-map"></a>
       <h2>Get Elements From a Java Map</h2>

       <p>
             To get a specific element stored in a Java <code>Map</code> you call its <code>get()</code> method,
             passing
             along the key for that element as parameter. Here is an example of getting a value stored in a Java
             <code>Map</code>:
       </p>

       <pre class="containers">Map map = new HashMap(); <br/>
<br/>
map.put("key1", "value 1"); <br/>
<br/>
String element1 = (String) map.get("key1"); <br/>
</pre>

       <p>
             Notice that the <code>get()</code> method returns a Java <code>Object</code>, so we have to cast it to
             a
             <code>String</code> (because we know the value is a String). Later in this Java Map tutorial you will
             see
             how to use Java Generics to type the <code>Map</code> so it knows what specific key and value types it
             contains.
             This makes type casting unnecessary, and makes it harder to insert the wrong values into the
             <code>Map</code>
             by accident.
       </p>

       <p>
             If we had specified a generic type for the key and value of the Map, then it would not have been
             necessary to
             cast the object returned by <code>get()</code> method. Here is how that would look:
       </p>

       <pre class="containers">Map&lt;String, String&gt; map = new HashMap&lt;&gt;(); <br/>
<br/>
map.put("key1", "value 1"); <br/>
<br/>
String element1 = map.get("key1"); <br/>
</pre>



       <a name="get-or-default-value"></a>
       <h3>Get or Default Value</h3>

       <p>
             The Java <code>Map</code> interface has a <code>getOrDefault()</code> method which can return a
             default
             value supplied by you - in case no value is stored in the <code>Map</code> by the given key. Here is
             an example
             of getting a value from a Java <code>Map</code> with a backup default value:
       </p>

       <pre class="containers">Map&lt;String, String&gt; map = new HashMap&lt;&gt;(); <br/>
<br/>
map.put("A", "1"); <br/>
map.put("B", "2"); <br/>
map.put("C", "3"); <br/>
<br/>
String value = map.getOrDefault("E", "default value"); <br/>
</pre>

       <p>
             This example creates a <code>Map</code> and stores three values in it using the keys <code>A</code>,
             <code>B</code> and <code>C</code>. Then the example calls the <code>Map</code>
             <code>getOrDefault()</code>
             method, passing the String <code>E</code> as key, along with a default value - the String
             <code>default value</code>. Since the <code>Map</code> does not contain any object stored by the key
             <code>E</code>
             the given default value will be returned - which is the String <code>default value</code> passed as
             the last
             parameter to the <code>getOrDefault()</code> method.
       </p>




       <a name="checking-if-map-contains-key"></a>
       <h2>Checking if Map Contains Key</h2>

       <p>
             You can check if a Java <code>Map</code> contains a specific key using the <code>containsKey()</code>
             method.
             Here is how that looks:
       </p>

       <pre class="containers">boolean hasKey = map.containsKey("123");
</pre>

       <p>
             After running this code, the <code>hasKey</code> variable will have the value <code>true</code> if a
             key + value
             pair was inserted earlier with the String key <code>123</code>, and false if no such key + value pair
             was inserted.
       </p>



       <a name="checking-if-map-contains-value"></a>
       <h2>Checking if Map Contains Value</h2>

       <p>
             The Java <code>Map</code> interface also has a method that enables you to check if the
             <code>Map</code> contains
             a certain value. The method is called <code>containsValue()</code> . Here is how calling the
             <code>containsValue()</code>
             looks:
       </p>

       <pre class="containers">boolean hasValue = map.containsValue("value 1");
</pre>

       <p>
             After executing this code the <code>hasValue</code> variable will contain the value <code>true</code>
             if
             a key + value pair was inserted ealier with the String value <code>"value 1"</code>, and false if not.
       </p>




       <a name="iterating-the-keys-of-a-java-map"></a>
       <h2>Iterating the Keys of a Java Map</h2>

       <p>
             There are several ways to iterate the keys stored in a Java <code>Map</code>. The most used methods
             for iterating the keys are:
       </p>

       <ul>
             <li>Via the key <code>Iterator</code></li>
             <li>Via the for-each loop</li>
             <li>Via a <code>Stream</code></li>
       </ul>

       <p>
             All methods will be covered in the following sections.
       </p>



       <a name="using-a-key-iterator"></a>
       <h3>Using a Key Iterator</h3>

       <p>
             You can iterate all the keys of a Java <code>Map</code> via its <code>keySet()</code> method.
             Here is how iterating the keys of a Java <code>Map</code> looks:
       </p>

       <pre class="containers">Iterator iterator = map.keySet().iterator(); <br/>
<br/>
while(iterator.hasNext()&#123; <br/>
Object key   = iterator.next(); <br/>
Object value = map.get(key); <br/>
&#125; <br/>
</pre>

       <p>
             As you can see, the key <code>Iterator</code> returns every key stored in a Java <code>Map</code>, one
             by one
             (one for each call to <code>next()</code>). Once you have the key, you can obtain the element stored
             for that
             key using the <code>Map</code> <code>get()</code> method.
       </p>

       <p>
             In the example above, the Iterator <code>next()</code> method returns an Object - and so does the
             <code>get()</code>
             method. With generic types specified for the Map these methods would have returned the type of the key
             and value
             objects respectively. Here is how that would look:
       </p>


       <pre class="containers">Map&lt;String, String&gt; map = new HashMap&lt;&gt;(); <br/>
<br/>
Iterator&lt;String&gt; iterator = map.keySet().iterator(); <br/>
<br/>
while(iterator.hasNext()&#123; <br/>
String key   = iterator.next(); <br/>
String value = map.get(key); <br/>
&#125; <br/>
</pre>

       <p>
             Notice how a generic type is now also specified for the Iterator obtained from
             <code>map.keySet().iterator()</code>.
       </p>




       <a name="using-a-key-for-each-loop"></a>
       <h3>Using a Key For-Each Loop</h3>

       <p>
             From Java 5 you can also use the for-each loop to iterate the keys stored in a Java <code>Map</code>.
             Here is how that looks:
       </p>

       <pre class="containers">for(Object key : map.keySet()) &#123;  <br/>
Object value = map.get(key); <br/>
&#125;
</pre>

       <p>
             The effect of the above code is pretty similar to the code shown in the previous section.
       </p>

       <p>
             If you have specified a generic type for the Java Map, then you can use that type inside the for-each
             loop.
             Here is how that looks:
       </p>


       <pre class="containers">Map&lt;String, String&gt; map = new HashMap&lt;&gt;(); <br/>
<br/>
for(String key : map.keySet()) &#123; <br/>
String value = map.get(key); <br/>
&#125; <br/>
</pre>



       <a name="using-a-key-stream"></a>
       <h3>Using a Key Stream</h3>

       <p>
             From Java 8 you can use a Java <code>Stream</code> to iterate the keys of a Java <code>Map</code>.
             The <code>Stream</code> interface is part of the
             Java Stream API which was added in Java 8.
             You first obtain the key <code>Set</code> from the <code>Map</code> and from that you can get a
             <code>Stream</code>. Here is an example of iterating the keys of a Java <code>Map</code> via a
             <code>Stream</code>:
       </p>

       <pre class="containers">Map&lt;String, String&gt; map = new HashMap&lt;&gt;(); <br/>
<br/>
map.put("one", "first"); <br/>
map.put("two", "second"); <br/>
map.put("three", "third"); <br/>
<br/>
Stream&lt;String&gt; stream = map.keySet().stream(); <br/>
stream.forEach((value) -&gt; &#123; <br/>
System.out.println(value); <br/>
&#125;);     <br/>
</pre>



       <a name="iterating-the-values-of-a-java-map"></a>
       <h2>Iterating the Values of a Java Map</h2>
       <p>
             It is also possible to just iterate the values stored in a Java <code>Map</code>. You obtain a
             <code>Collection</code>
             of the values stored in a <code>Map</code> via the <code>values()</code> method. You can iterate the
             values
             in the <code>Collection</code> in following ways:
       </p>

       <ul>
             <li>Using an Iterator</li>
             <li>Using the for-each Loop</li>
             <li>Using a value Stream</li>
       </ul>

       <p>
             All of these options are covered in the following sections.
       </p>



       <a name="using-a-value-iterator"></a>
       <h3>Using a Value Iterator</h3>

       <p>
             The first way to iterate all values stored in a Java <code>Map</code> is to obtain a value
             <code>Iterator</code>
             instance from the value <code>Set</code>, and iterate that. Here is how iterating the values stored in
             a
             Java <code>Map</code> using a value <code>Iterator</code>:
       </p>

       <pre class="containers">Map&lt;String, String&gt; map = new HashMap&lt;&gt;(); <br/>
<br/>
Iterator&lt;String&gt; iterator = map.values().iterator(); <br/>
<br/>
while(iterator.hasNext()) &#123; <br/>
String nextValue  iterator.next(); <br/>
&#125; <br/>
</pre>

       <p>
             Since a <code>Set</code> is unordered, you do not have any guarantees about the order in which the
             values
             in the value set are iterated. However, if you are using a TreeSet you can control this order still.
       </p>




       <a name="using-a-value-for-each-loop"></a>
       <h3>Using a Value For-Each Loop</h3>

       <p>
             The second method of iterating the values stores in a Java <code>Map</code> is via the Java for-each
             loop.
             Here is how iterating the values of a Java <code>Map</code> using the for-each loop looks in code:
       </p>

       <pre class="containers">Map&lt;String, String&gt; map = new HashMap&lt;&gt;(); <br/>
<br/>
for(String value : map.values())&#123; <br/>
System.out.println(value); <br/>
&#125; <br/>
</pre>

       <p>
             This example will print out all the values store in the <code>mapA</code> <code>Map</code> variable.
       </p>



       <a name="using-a-value-stream"></a>
       <h3>Using a Value Stream</h3>

       <p>
             The third way to iterate the values stored in a Java <code>Map</code> is by using a value
             <code>Stream</code>,
             by using the Java Stream API. You first obtain
             the
             value <code>Set</code> from the <code>Map</code>, and from the value <code>Set</code> you can obtain
             the
             <code>Stream</code>. Here is an example of iterating the values of a Java <code>Map</code> via a
             value <code>Stream</code>:
       </p>

       <pre class="containers">Map&lt;String, String&gt; map = new HashMap&lt;&gt;(); <br/>

map.put("one", "first"); <br/>
map.put("two", "second"); <br/>
map.put("three", "third"); <br/>
<br/>
Stream&lt;String&gt; stream = map.values().stream(); <br/>
stream.forEach((value) -&gt; &#123; <br/>
System.out.println(value); <br/>
&#125;); <br/>

</pre>




       <a name="iterating-the-entries-of-a-java-map"></a>
       <h2>Iterating the Entries of a Java Map</h2>

       <p>
             It is also possible to iterate all entries of a Java <code>Map</code>. By entries I mean key + value
             pairs.
             An entry contains both the key and value for that entry. Earlier we have only iterated either the
             keys, or
             the values, but by iterating the entries we iterate both at the same time.
       </p>

       <p>
             Like with keys and values, there are two ways to iterate the entries of a <code>Map</code>:
       </p>

       <ul>
             <li>Using an Entry Iterator</li>
             <li>Using the for-each loop</li>
       </ul>

       <p>
             Both of these options will be explained in the following sections.
       </p>




       <a name="using-an-entry-iterator"></a>
       <h3>Using an Entry Iterator</h3>

       <p>
             The first way to iterate the entries of a Java <code>Map</code> is via an entry <code>Iterator</code>
             obtained from the entry <code>Set</code>. Here is an example of iterating the entries of Java
             <code>Map</code>:
       </p>

       <pre class="containers">Set&lt;Map.Entry&lt;String, String&gt;&gt; entries = map.entrySet(); <br/>
<br/>
Iterator&lt;Map.Entry&lt;String, String&gt;&gt; iterator = <br/>
entries.iterator(); <br/>
<br/>
while(iterator.hasNext()) &#123; <br/>
Map.Entry&lt;String, String&gt; entry = iterator.next(); <br/>
String key   = entry.getKey(); <br/>
String value = entry.getValue(); <br/>
&#125; <br/>
</pre>

       <p>
             Notice how the key and value can be obtained from each <code>Map.Entry</code> instance.
       </p>

       <p>
             Keep in mind that the above code can be made a bit nicer using a <code>Map</code> typed with Java Generics
             as shown later in this tutorial.
       </p>



       <a name="using-an-entry-for-each-loop"></a>
       <h3>Using an Entry For-Each Loop</h3>

       <p>
             The second way to iterate the entries of a Java <code>Map</code> is to use a for-each loop. Here is an
             example
             of iterating the entries of a Java <code>Map</code> using a for-each loop:
       </p>

       <pre class="containers">for(Map.Entry&lt;String, String&gt; entry : map.entrySet())&#123; <br />
String key = entry.getKey(); <br />
String value = entry.getValue(); <br />
&#125; <br />
</pre>

       <p>
             Notice, that this example too can be made a bit prettier using a generic <code>Map</code>. Generic
             <code>Map</code>
             instance are explained a bit later in this Java Map tutorial.
       </p>




       <a name="remove"></a>
       <h2>Removing Entries From a Java Map</h2>
       <p>
             You remove Entries by calling the <code>remove(Object key)</code> method. You thus remove the
             (key, value) pair matching the key. Here is an example of removing the entry for a given key in
             a Java <code>Map</code> :
       </p>

       <pre class="containers">map.remove("key1");
</pre>

       <p>
             After executing this instruction, the <code>Map</code> referenced by <code>mapA</code> will no longer
             contain
             an entry (key + value pair) for the key <code>key1</code>.
       </p>




       <a name="removing-all-entries"></a>
       <h2>Removing All Entries</h2>
       <p>
             You can remove all entries in a Java <code>Map</code> using the <code>clear()</code> method. Here is
             how that looks:
       </p>

       <pre class="containers">map.clear();
</pre>




       <a name="replacing-an-entry-in-a-java-map"></a>
       <h2>Replacing an Entry in a Java Map</h2>

       <p>
             It is possible to replace an element in a Java <code>Map</code> using the <code>replace()</code>
             method.
             The <code>replace()</code> method will only insert the new value if there is already an existing value
             mapped to the key. If no existing value is mapped to the given key, no value is inserted. This is
             different
             from how <code>put()</code> works, which always insert the value no matter what.
       </p>

       <p>
             Here is an example of replacing one value with another using the Java <code>Map</code>
             <code>replace()</code>
             method:
       </p>

       <pre class="containers">Map<string > map = new HashMap&lt;&gt;(); <br />
 <br />
map.replace("key", "val2"); //no "key" entry, no replace <br />
 <br />
map.put("key", "val1");     //now contains "key" entry <br />
 <br />
map.replace("key", "val2"); //now "key" entry replaced <br />
</string></pre>

       <p>
             After running this code the <code>Map</code> instance will contain the String value
             <code>newer value</code>
             for the String key <code>key</code> .
       </p>





       <a name="reading-number-of-entries-in-map"></a>
       <h2>Reading Number of Entries in Map</h2>

       <p>
             You can read the number of entries in a Java <code>Map</code> using the <code>size()</code> method.
             The number of entries in a Java <code>Map</code> is also referred to as the <code>Map</code>
             <em>size</em>
             - hence the method name <code>size()</code> .
             Here is an example of reading the number of entries in a Map using the <code>size()</code> method:
       </p>

       <pre class="containers">int entryCount = map.size();
</pre>




       <a name="checking-if-a-java-map-is-empty"></a>
       <h2>Checking if a Java Map is Empty</h2>

       <p>
             The Java <code>Map</code> interface has a special method for checking if a <code>Map</code> is empty.
             This method is called <code>isEmpty()</code> and it returns either <code>true</code> or
             <code>false</code>.
             The <code>isEmpty()</code> method will return <code>false</code> if the <code>Map</code> instance
             contains
             1 or more entries. If the <code>Map</code> contains 0 entries, <code>isEmpty()</code> will return
             <code>true</code>.
       </p>




       <a name="functional-operations"></a>
       <h2>Functional Operations in Java Map</h2>

       <p>
             The Java <code>Map</code> interface had a few functional operations added from Java 8. These
             functional operations
             make it possible to interact with a <code>Map</code> in a more functional style. For instance, you
             pass
             a Java Lambda Expression as parameter to these functional
             style
             methods. You can read more about functional programming in my tutorial about
             Java Functional Programming .
       </p>

       <p>
             The functional operation methods are:
       </p>

       <ul>
             <li>compute()</li>
             <li>computeIfAbsent()</li>
             <li>computeIfPresent()</li>
             <li>merge()</li>
       </ul>

       <p>
             Each of these functional methods will be described in more detail in the following sections.
       </p>



       <a name="compute"></a>
       <h3>compute()</h3>

       <p>
             The <code>Map</code> <code>compute()</code> method takes a key object and a lambda expression as
             parameters.
             The lambda expression must implement the <code>java.util.function.BiFunction</code> interface. Here
             is an example of calling the Java <code>Map</code> <code>compute()</code> method:
       </p>

       <pre class="containers">map.compute("123", (key, value) -&gt; <span class="smallScreen"><br/>    </span>value == null ? null : <span class="smallScreen"><br/>        </span>value.toString().toUpperCase());
</pre>

       <p>
             The <code>compute()</code> method will call the lambda expression internally, passing the key object
             and whatever value is stored in the <code>Map</code> for that key object, as parameters to the lambda
             expression.
       </p>

       <p>
             Whatever value the lambda expression returns is stored instead of the currently stored value for that
             key.
             If the lambda expression returns <code>null</code>, the entry is removed. There will not be a key
             -&gt; <code>null</code>
             mapping stored in the <code>Map</code>.
       </p>

       <p>
             In the example above you can see that the lambda expression checks if the value mapped to the given
             key is
             <code>null</code> or not, before calling <code>toString().toUpperCase()</code> on it.
       </p>

       <p>
             It the lambda expression throws an exception, the entry is also removed.
       </p>



       <a name="computeifabsent"></a>
       <h3>computeIfAbsent()</h3>

       <p>
             The <code>Map</code> <code>computeIfAbsent()</code> method works similarly to the
             <code>compute()</code>
             method, but the lambda expression is only called if no entry exists already for the given key.
       </p>

       <p>
             The value returned by the lambda expression is inserted into the <code>Map</code>. If
             <code>null</code>
             is returned, no entry is inserted.
       </p>

       <p>
             If an exception is thrown by the lambda expression, no entry is inserted either.
       </p>

       <p>
             Here is an example of calling the <code>Map</code> <code>computeIfAbsent()</code> method:
       </p>

       <pre class="containers">map.computeIfAbsent("123", (key) -&gt; "abc");
</pre>

       <p>
             This example actually just returns a constant value - the string <code>123</code> . However, the
             lambda expression could have calculated the value in any way it needed to - e.g. extract the value
             from another object, or concatenate it from other values etc.
       </p>



       <a name="computeifpresent"></a>
       <h3>computeIfPresent()</h3>

       <p>
             The <code>Map</code> <code>computeIfPresent()</code> method works oppositely of
             <code>computeIfAbsent()</code>.
             It only calls the lambda expression passed as parameter to it, if an entry already exists in the
             <code>Map</code>
             for that key. Here is an example of calling the <code>computeIfPresent()</code> method:
       </p>

       <pre class="containers">map.computeIfPresent("123", (key, value) -&gt; <span class="smallScreen"><br/>    </span>value == null ? null : <span class="smallScreen"><br/>        </span>value.toString().toUpperCase());
</pre>

       <p>
             The value returned by the lambda expression will be inserted into the <code>Map</code> instance. If
             the lambda expression returns <code>null</code>, the entry for the given key is removed.
       </p>

       <p>
             If the lambda expression throws an exception, the exception is rethrown, and the current entry for the
             given
             key is left unchanged.
       </p>



       <a name="merge"></a>
       <h3>merge()</h3>

       <p>
             The <code>Map</code> <code>merge()</code> method takes a key, a value, and a lambda expression
             implementing the
             <code>BiFunction</code> interface as parameters.
       </p>

       <p>
             If the <code>Map</code> does not have an entry for the key, or if the value for the key is null,
             the value passed as parameter to the <code>merge()</code> method is inserted for the given key.
       </p>

       <p>
             If, however, an existing value is already mapped to the given key, the lambda expression passed as
             parameter
             is called instead. The lambda expression thus gets a chance to <em>merge</em> the existing value with
             a new
             value. The value returned by the lambda expression is then inserted into the <code>Map</code> for the
             given
             key. If the lambda expression returns <code>null</code>, the entry for the given key is removed.
       </p>

       <p>
             Here is an example of calling the <code>Map</code> <code>merge()</code> method:
       </p>

       <pre class="containers">map.merge("123", "XYZ", <span class="smallScreen"><br/>    </span>(oldValue, newValue) -&gt; newValue + "-abc");
</pre>

       <p>
             This example will insert the value <code>XYZ</code> into the <code>Map</code> if no value is mapped to
             the
             key (<code>123</code>), or if <code>null</code> is mapped to the key. If a non-null value is already
             mapped
             to the key, the lambda expression is called. The lambda expression returns the new value
             (<code>XYZ</code>)
             + the value <code>-abc</code>, meaning <code>XYZ-abc</code>.
       </p>

       <p>
             If an exception is thrown by the lambda expression, the exception is rethrown, and the current mapping
             for
             the given key is kept unchanged.
       </p>




       <a name="javadoc"></a>
       <h2>More Details in the Java Map JavaDoc</h2>

       <p>
             There is more you can do with a <code>Map</code>, but you will have to check out the JavaDoc
             for more details. This text focused on the two most common operations: Adding / removing elements,
             and iterating the keys and values.
       </p>
 </div>

<br/>

</div>
        </div>
    )
}

export default Jva_map
